import React, { Component } from "react";
import PropTypes from "prop-types";
import { ButtonCommonTheme } from "modules/theme";
import {
  FormGroup,
  FormControl,
  Spinner,
  EmptyState,
  ControlLabel,
} from "modules/common/components";
import { Modal } from "react-bootstrap";
import { Column, Columns, DataWrapperClass, Title } from "../styles/main";
import { ModalFooter, CenterContent } from "modules/common/styles/main";
import APIManager from "modules/common/apiManager";
import { Alert } from "modules/common/utils";
import Icon from "./Icon";

const contextTypes = {
  __: PropTypes.func,
};

class ChooserSelector extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.save = this.save.bind(this);
    this.renderNonSelected = this.renderNonSelected.bind(this);
    this.search = this.search.bind(this);
    this.mAPI = new APIManager();
    this.timer = "";
    this.actualList = [];
    this.state = {
      showHide: false,
      search: "",
      selectedLoader: false,
      nonSelectedLoader: false,
      elementId: props.elementId,
      selected: [],
      list: [],
    };
  }
  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.elementId !== this.state.elementId) {
      this.setState({ elementId: nextProps.elementId });
      if (nextProps.elementId != "") {
        this.selectedElements(nextProps.elementId);
      }
    }
  }

  componentWillUnmount() {
    // this.props.clearState();
  }

  handleModal() {
    this.setState({
      showHide: !this.state.showHide,
    });
  }

  closeModal() {
    this.setState({ showHide: false });
  }
  openModal() {
    this.setState({ showHide: true });
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }
  handleChange(type, data) {
    const { selected, list } = this.state;
    if (type === "add") {
      // if ( this.props.limit && this.props.limit === datas.length) {
      //   return;
      // }
      let list = [];
      try {
        list = this.state.list.filter((el) => {
          return el._id !== data._id;
        });
      } catch (error) {
        console.log(`List update error`);
      }
      this.setState({ selected: [data, ...selected], list: list });
    } else {
      this.setState({
        selected: selected.filter((item) => item !== data),
        list: [data, ...list],
      });
    }
  }
  renderRow(data, icon) {
    if (icon === "add" && this.state.selected.some((e) => e._id === data._id)) {
      return null;
    }

    return (
      <li key={data._id} onClick={() => this.handleChange(icon, data)}>
        {data.name}
        <Icon icon={icon} />
      </li>
    );
  }
  renderNonSelected(list) {
    if (this.state.nonSelectedLoader) {
      return <Spinner />;
    } else if (list.length) {
      return <ul>{list.map((data) => this.renderRow(data, "add"))}</ul>;
    }
    return <EmptyState text="No items" icon="list-2" />;
  }
  renderSelected(selected) {
    if (this.state.selectedLoader) {
      return <Spinner />;
    } else if (selected.length) {
      return (
        <ul>{selected.map((data) => this.renderRow(data, "minus-circle"))}</ul>
      );
    }
    return <EmptyState text="No items added" icon="list-2" />;
  }

  render() {
    const { __ } = this.context;
    const { showHide = false, modalSize = "lg" } = this.props;
    return (
      <Modal size={modalSize} show={this.state.showHide}>
        <Modal.Body>
          <form onSubmit={(e) => this.save(e)}>
            <Columns>
              <Column>
                <FormControl
                  placeholder={"Type to search"}
                  onChange={this.search}
                />
                <ul>{this.renderNonSelected(this.state.list)}</ul>
              </Column>
              <Column>
                <Title>
                  Responders
                  <span>{this.state.selected.length}</span>
                </Title>
                {this.renderSelected(this.state.selected)}
              </Column>
            </Columns>
            <ModalFooter>
              <ButtonCommonTheme
                type="greyModalBtn"
                icon="cancel-1"
                size="small"
                style={{ marginRight: "10px" }}
                modalBtnTitle="Cancel"
                onClick={() => this.handleModal()}
              />
              <ButtonCommonTheme
                icon="checked-1"
                type="blueModalBtn"
                btnType="submit"
                modalBtnTitle="Select"
              />
            </ModalFooter>
          </form>
        </Modal.Body>
      </Modal>
    );
  }
  apiResponse(errorCode, data) {
    if (errorCode === 0) {
      let message = "File Successfully Updated.";
      message = data && data.message ? data.message : "Successfully updated";
      Alert.success(`${message}`);
      this.closeModal();
    } else {
      let message = data && data.message ? data.message : "Upload Error";
      Alert.error(`${message}`);
    }
  }
  nonSelectedElements(selected, searchText = "") {
    this.setState({ nonSelectedLoader: true });
    var that = this;
    let { searchUrl = "", searchProcess } = this.props;

    selected.map((data) => {
      searchUrl += "&excluded=" + data._id;
    });
    if (searchText) {
      searchUrl += "&search=" + searchText;
    }

    this.mAPI.sendGetAPI(
      searchUrl,
      (data) => {
        let list = [];
        if (typeof searchProcess === "function") {
          list = searchProcess(data);
        }
        if (list) {
          that.setState({ list: list, nonSelectedLoader: false });
        }
      },
      (error, data) => {
        this.setState({ nonSelectedLoader: false, list: [] });
        // if (data) {
        //   Alert.error(`${error} : ${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }
  selectedElements(elementId) {
    this.setState({
      selectedLoader: true,
      nonSelectedLoader: true,
      showHide: true,
    });
    var that = this;
    let { selectedUrl = "", selectedProcess } = this.props;
    selectedUrl = selectedUrl.replace("<elementId>", elementId);
    this.actualList = [];
    this.mAPI.sendGetAPI(
      selectedUrl,
      (data) => {
        this.setState({ selectedLoader: false });
        let list = [];
        if (typeof selectedProcess === "function") {
          list = selectedProcess(data);
        }
        if (list) {
          this.actualList = list;
          that.setState({ selected: list });
        }
        this.nonSelectedElements(list);
      },
      (error, data) => {
        // this.setState({"selectedLoader":false});
        this.setState({
          nonSelectedLoader: false,
          selectedLoader: false,
          selected: [],
        });
        // if (data) {
        //   Alert.error(`${error} : ${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }
  save(e) {
    /* prevent the result */
    e.preventDefault();

    let _this = this;
    let { finalUrl = "", fetchData, elementId } = this.props;
    finalUrl = finalUrl.replace("<elementId>", elementId);

    /* */
    let added = [],
      removed = [];

    this.actualList.map((data) => {
      if (!this.state.selected.some((e) => e._id === data._id)) {
        removed.push(data._id);
      }
    });
    this.state.selected.map((data) => {
      if (!this.actualList.some((e) => e._id === data._id)) {
        added.push(data._id);
      }
    });
    let formData = fetchData(added, removed);

    this.mAPI.sendPostAPI(
      `${finalUrl}`,
      formData,
      (data) => {
        //Set the progress value to show the progress bar
        Alert.success(`Updated Successfully.`);
        this.closeModal();
        // this.handleModalShowImport();
        // this.resetAllData();
        // this.getList();
      },
      (errorCode, data) => {
        this.apiResponse(errorCode, data);
      },
      "private",
      {},
      "PUT"
    );
  }
  search(e) {
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      const _this = this;

      if (_this.timer) clearTimeout(_this.timer);
      _this.timer = setTimeout(() => {
        _this.setState({ search: value });
        _this.nonSelectedElements(this.state.selected, this.state.search);
      }, 500);
    }
  }
}

ChooserSelector.contextTypes = contextTypes;

export default ChooserSelector;



// WEBPACK FOOTER //
// src/modules/common/components/ChooserSelector.js